module.exports = __webpack_public_path__ + "static/img/edgarTrejoImg_1.4048962e.webp";